export var SUBLET_TYPE = {
  RO: 'RO',
  VEHICLE: 'VEHICLE',
  WITHOUT_REFERENCE: 'NO_REF',
  SERVICE_SUBLET: 'SERVICE_SUBLET'
};